export default __webpack_public_path__ + "static/media/default.75d6fd20.svg";